import $ from "jquery";

$(() => {
    $('#nav-form input').on('keydown', function (event) {
        if (event.which === 13) {
            event.preventDefault();
            $("#nav-form").submit();
        }
    })
});
